import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { IRotatingIconButtonProps, RotationType } from './RotatingIconButton.interface';

const getRotationAngle = (
  reverse: boolean,
  rotationType: RotationType = RotationType.Half,
): number => {
  switch (rotationType) {
    case RotationType.Quarter:
      return reverse ? 90 : 0; // 0° или 90°
    case RotationType.Half:
      return reverse ? 270 : 90; // 90° (вниз) или 270° (вверх)
    case RotationType.None:
    default:
      return 0;
  }
};

export const RotatingIconButton = styled((props: IRotatingIconButtonProps) => {
  const { reverse, rotatingMode, rotationType, ...other } = props;
  return <IconButton size={'small'} {...other} />;
})(
  ({
    rotatingMode = 'rotate',
    reverse,
    rotationType = RotationType.Half,
    theme,
  }) => ({
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    transform: `${rotatingMode}(${getRotationAngle(reverse, rotationType)}deg)`,
  }),
);
